import React from "react";
import Checkbox from "canvas-core-react/lib/Checkbox";

const CustomCheckbox = ({ className, error, ...restProps }) => (
  <Checkbox {...restProps} className={getClassName(className, error)} />
);

export default CustomCheckbox;

const getClassName = (customClass, error) => {
  const className = customClass || "";
  const errorClass = error ? "error-text-color" : "";
  return `canvas-checkbox-fix ${className} ${errorClass}`;
};
